document.addEventListener('DOMContentLoaded', function()
{
    const cards = document.querySelectorAll('.card-value');

    const animateCount = function(el, target)
    {
        const isPercentage = target.includes('%');
        const isPlus = target.startsWith('+');
        const numeric = parseFloat(target.replace(/[^\d]/g, ''));
        const duration = 1500;
        const stepTime = 20;
        let current = 0;
        const increment = numeric / (duration / stepTime);

        const update = function()
        {
            current += increment;

            if (current >= numeric) {
                el.textContent = target;
            } else {
                let display = Math.floor(current);
                if (isPercentage) display += '%';
                if (isPlus) display = '+' + display;
                el.textContent = display;
                requestAnimationFrame(update);
            }
        }

        update();
    };

    const observer = new IntersectionObserver(function(entries)
    {
        entries.forEach(function(entry)
        {
            if (entry.isIntersecting) {
                const el = entry.target;
                const valor = el.getAttribute('data-valor');

                if(!el.classList.contains('done')) {
                    animateCount(el, valor);
                    el.classList.add('done');
                }
            }
        });
    }, {
        threshold: 0.9
    });

    cards.forEach(card => observer.observe(card));
});
